<div class="w-screen relative h-[2px] sm:h-[1px]">
    <img src="/images/footer/breaker.svg" alt="breaker" class="block w-full h-full m-0 p-0" />
</div>
<div
    class="flex flex-col sm:flex-row w-full bg-black justify-between items-center sm:items-start px-[10%] py-[50px] font-outfit text-white gap-y-[40px] sm:gap-y-0 sm:gap-x-[40px] text-center sm:text-left">

    <div routerLink="/" class="w-full sm:w-auto sm:self-start cursor-pointer">
        <img class="mb-[24px] mx-auto sm:mx-0" src="/images/footer/logo.svg" alt="logo" />
        <span>
            98 Cuttermill Road STE 223N,<br />
            Great Neck, New York, 11024
        </span>
    </div>

    <div class="w-full sm:w-auto text-[16px] font-bold flex flex-col gap-[14px] items-center sm:items-start">
        <a class="cursor-pointer" routerLink="/" fragment="services"><span>services</span></a>
        <a class="cursor-pointer" routerLink="/" fragment="case-studies"><span>case studies</span></a>
        <a class="cursor-pointer" href="/blog/"><span>blog</span></a>
        <a class="cursor-pointer" routerLink="/privacy-policy"><span>privacy policy</span></a>
    </div>

    <div class="w-full sm:w-auto self-start">
        <img class="mb-[24px] mx-auto sm:mx-0" src="/images/footer/follow.svg" alt="follow us" />
        <div class="flex gap-[5px] justify-center sm:justify-start">
            <a href="https://www.facebook.com/people/SEMnexus/100065162281996/" target="_blank" rel="noopener">
                <img class="hover:brightness-0 hover:invert transition" src="/images/footer/facebook.svg"
                    alt="facebook" />
            </a>
            <a href="https://www.instagram.com/semnexus_digital/" target="_blank" rel="noopener">
                <img class="hover:brightness-0 hover:invert transition" src="/images/footer/instagram.svg"
                    alt="instagram" />
            </a>
            <a href="https://www.linkedin.com/company/semnexus" target="_blank" rel="noopener">
                <img class="hover:brightness-0 hover:invert transition" src="/images/footer/linkedin.svg"
                    alt="linkedin" />
            </a>
        </div>
    </div>

    <form #newsletterForm="ngForm">
        <div class="w-full sm:w-auto self-start flex flex-col items-center sm:items-start">
            <span class="mb-2 text-[16px] font-bold">our newsletter</span>

            <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" name="name"
                [(ngModel)]="newsletter.name"
                class="w-[230px] h-[42px] rounded-[36px] bg-white/20 backdrop-blur-md px-4 text-white placeholder-white outline-none mb-[5px]"
                placeholder="name" type="text" required />

            <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" name="email"
                [(ngModel)]="newsletter.email"
                class="w-[230px] h-[42px] rounded-[36px] bg-white/20 backdrop-blur-md px-4 text-white placeholder-white outline-none mb-[12px]"
                placeholder="email" type="email" required />

            <app-button buttonText="subscribe!" (clicked)="subscribe()">
            </app-button>
        </div>
    </form>
</div>